import { render, staticRenderFns } from "./PowerofAttorney.vue?vue&type=template&id=3f3a73c4&scoped=true"
import script from "./PowerofAttorney.vue?vue&type=script&lang=ts"
export * from "./PowerofAttorney.vue?vue&type=script&lang=ts"
import style0 from "./PowerofAttorney.vue?vue&type=style&index=0&id=3f3a73c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a73c4",
  null
  
)

export default component.exports